import React from 'react'
import { useOnNavigate, useRouter } from '@morningtrain/react-navigation'

export default function ActiveWhenOnRoute ({ route, children }) {
  const router = useRouter()

  function checkIfActive () {
    return route === router.currentRoute
  }

  const [isActive, setIsActive] = React.useState(checkIfActive())

  useOnNavigate(() => {
    const status = checkIfActive()
    if (status !== isActive) {
      setIsActive(status)
    }
  }, [route, isActive])

  if (typeof children === 'function') {
    return children({ active: isActive })
  }

  return React.Children.map(children, (child, i) => React.cloneElement(child, { active: isActive }))
}
